import { config } from '../_config/config';
export const ASSETS_URL = config.ASSETS_URL;